export default function ({value}) {
    return String(value);
}
